import { TBancos } from "../financeiro/bancos"

export interface IDataPublicos {
    tipo_publico: string,
    codigo_publico: string,
    nome_pessoa: string,
    tipo_pessoa: string,
    documento_pessoa: string,
    endereco: string,
    bairro: string,
    cep: string,
    processo?: TProcessoPublicos[]
    cidade: {
        id: number,
        nome: string,
        estado: string
    },
    telefone: string,
    email: string,
    limite_credito: string,
    limite_utilizado: string,
    limite_disponivel: string,
    situacao_financeira: string,
    ranking: string,
    comprador: string,
    conta_cheque?: TContaChequePublico | null,
    selected_fazenda: TFazendaPublico | null,
    fazendas: TFazendaPublico[]
    dia_vencimento_padrao: number,
}

export type TProcessoPublicos = {
    codigo: string,
    titulo: string,
    situacao: 'Em execução' | 'Finalizado' | 'Suspenso'
}

export const clienteDefValue = {
    tipo_publico: "",
    codigo_publico: "",
    nome_pessoa: "",
    tipo_pessoa: "",
    documento_pessoa: "",
    endereco: "",
    bairro: "",
    cep: "",
    cidade: {
        id: 0,
        nome: "",
        estado: ""
    },
    processo: [],
    telefone: "",
    email: "",
    limite_credito: "",
    limite_utilizado: "",
    limite_disponivel: "",
    situacao_financeira: "",
    ranking: "",
    comprador: "",
    conta_cheque: null,
    selected_fazenda: null,
    fazendas: [],
    dia_vencimento_padrao: 20
}

export type TContaChequePublico = {
    conta: string;
    conta_digito: string;
    cidade: string;
    banco: TBancos
    agencia: string;
}

export type TFazendaPublico = {
    nome: string;
    apelido: number;
    inscricao: string;
    siare: string;
    cidade: string;
    estado: string;
    inscricao_vencimento: string;
}

export type TSituacaoFinanceiraPublico = "LIBERADO" | "BLOQUEADO DEFINITIVO" | "PENDENCIAS FINANCEIRAS"